import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, UrlSegment } from '@angular/router';
import { Router, NavigationEnd, ResolveEnd } from '@angular/router';
import { Location } from '@angular/common'
import { Subject } from "rxjs";
import { Product, ProductResponse } from '../../models/Product';
import { ProductService } from "../../services/product.service";
import { User } from '../../models/User';
import { AuthService } from '../../services/auth.service';
import { ProductsUrlType } from "../../services/utility/general-helper.service";
import * as $ from 'jquery';

//moved to general-utility service
// enum ProductsUrlType{
//   List,
//   Detail,
//   CardEdit,
//   DetailEdit
// }

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  ProductsUrlType = ProductsUrlType;
  urlType:ProductsUrlType = null;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  products: Product[];  //initially null until http_getProducts responds.  Will be passed down as input to children.
  product:Product;
  user: User;  //initially null.  Will be passed down to children's inputs.
  category:string = null;
  category_formatted:string = null;
  sku:string = null;
  // private subscriptions?: Subscription = new Subscription();  //keep track of subscriptions.  End them upon component.destroy().
  detectBackwardForward: boolean = false;
  private counter: number = 0;

  constructor(
    private route:ActivatedRoute,
    private router:Router,
    private location:Location,
    private productService:ProductService,
    private authService:AuthService
  ) { 
    //flag for no scrolling animation on browser 'forward/backward'
    this.location.subscribe((popStateEvent) => {  
      this.detectBackwardForward = true;
    }); 

  }


  ngOnInit() { 

    //Best practice: Each stream shall return only one data.
    //  Do not pass 'multiple return values values' down to the final 'subscribe'.
    //  Instead, handle them within the immediate switchmap when they become available.
    //  https://stackoverflow.com/questions/41834232/how-can-i-switchmap-2-observable-function-in-synchronous-fashion-but-get-the-fir
    this.route.url.first()
    .mergeMap((url) => {
      // console.log('1: url change detected');
      return this.route.params.do((params) => {
        // console.log('2: url + params change detected');
        this.category = params["category"];
        this.sku = params["sku"];
        this.category = params["category"];
        this.sku = params["sku"];
        this.urlType = this.getProductsUrlType(url, this.sku);
        this.category_formatted = this.getCategoryFormatted(this.category);    
      })
    })
    .switchMap(() => {
      return this.productService.loadAllProducts(true).first()
    })
    .switchMap( (products) => {
      //Products are now loaded...
      //Filter products down by category and active 
      this.product = this.productService.getProductBySku(this.sku);  //assign the product, or null if no sku
      let filteredProducts = this.productService.getProductsByCategory(this.category); 
      let activeProducts = Product.filterActiveProducts(filteredProducts);
      this.products = activeProducts;    

      return this.authService.user$;
    })
    .takeUntil(this.ngUnsubscribe)  //Always unsubscribe from infinite streams (caused by route.params)
    .subscribe( (user:User) => { 
      this.user = user;  // can be null
    });
 
    //detect ResolveEnd (NavigationEnd doesn't always fire, but ResolveEnd does)
    this.router.events
    .takeUntil(this.ngUnsubscribe)  //unsubscribe from infinite stream
    .subscribe((e) => {      
      if (e instanceof ResolveEnd && this.detectBackwardForward == false) {
        console.log('detected resolveEnd && !detectBackFor');
        this.animatePageToNavbar();  
      }
    });
  
  
  }

   //Determine the ProductsUrlType using url and parameters
   getProductsUrlType(url:UrlSegment[], sku:string){
    let urlType = ProductsUrlType.List;  //default
    let isEdit = url[1] != null ? url[1].path == 'edit' : false;
    if(isEdit == false){
      if(sku == null){
        urlType = ProductsUrlType.List
      } else {
        urlType = ProductsUrlType.Detail
      }
    } else {
      let editType = url[2].path  //(for admin): card, detail, or edit    
      if(editType == 'card'){
        urlType = ProductsUrlType.CardEdit;
      } else if(editType == 'detail'){
        urlType = ProductsUrlType.DetailEdit;
      } else {
        console.log('p-component: url not handled:', url);  
        console.log('using default urltype \'list\'');
        urlType = ProductsUrlType.List;
      }
    }
    // let urlTypeAsString = ProductsUrlType[urlType];  //Convert enum value to string
    // console.log('urlType', urlTypeAsString);
    return urlType;
  }

  //animate scroll to the bottom of the navbar if user scrolled content down.
  animatePageToNavbar(){
    console.log('products.component is animating to top')
    var tagtop = $('app-navbar div#banner').offset().top;
    var tagheight = $('app-navbar div#banner').outerHeight();
    var tagbottom = tagtop+tagheight;
    var windowscrolltop = $(window).scrollTop();
    let page = $('body');
    if (windowscrolltop > tagbottom) {
      page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
        page.stop();
      });
      page.animate({ scrollTop: tagbottom }, 300, function(){
        page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
      });
    }
    return false;
  }

  //properly formated 'category' to appear in the breadcrumb
  getCategoryFormatted(category){
    var category_formatted = category;
    switch (category) {
      case 'chocolatechip':
        category_formatted = 'ChocolateChip';
        break;
      case 'swirls':
        category_formatted = 'Swirls';
        break;
      case 'shortbread':
        category_formatted = 'Shortbread';
        break;
      case 'sweetdips':
        category_formatted = 'SweetDips';
        break;
      case 'giftbaskets':
        category_formatted = 'GiftBaskets';
        break;
    
      default:
        break;
    }
    return category_formatted;
  }
  
  ngOnDestroy() {
    console.log('*products component destroyed')
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
   }

}



//Unused code
// this.route.params.subscribe((params: Params) => {
//   // console.log('products: params.id:', params.id);
//   if(!params.id){
//     // console.log('detected /products, shall redirect to /products/chocolatechip');
//     this.router.navigate(['/products/chocolatechip']);
//   }
// });


// console.log('products: params', params);
// console.log('products: params.category:', params["category"]);
// console.log('products: params.productid:', params["productid"]);

// $('body').animate({ scrollTop: tagbottom }, 300);  //this worked, but had to append to stop animating when user scrolls.

        // $('html, body').animate({
        //   scrollTop: parseInt($("nav").offset().top)
        //   // scrollTop: 200
        // }, 2000);

        // $("nav").get(0).scrollIntoView();
        // $('body').scrollTo(500); // Scroll screen 500 pixels down
        // $('nav').scrollTop = 0;
        // $('body').scrollTo('nav');
      //   $('html, body').animate({
      //     scrollTop: $("nav").offset().top
      // }, 2000);

              // this.location.subscribe(event => {
        //   console.log("Location changed w/ event: ", event);
        //   return false;
        // });
        
        // this.platformLocation.onPopState(() => {
          
        //           console.log('pressed back!');
          
        //       }); 

        // this.counter += 1;
        // console.log('...incremented counter...');
        // let subscriber = this.location.subscribe((popstateevent) => {  
        //   console.log('popstateevent('+this.counter+'): ', popstateevent); 
        //   return false;
        // });
        // console.log('value from location.subscribe: ', subscriber);
        // console.log('e: ', e);
        // console.log('subscription is closed?: ', this.subscriptions);

              // let page = $('body');
      // page.clearQueue();
      // page.stop();

      // console.log('router event: ', e);
            // console.log('pressed back! -- locationChangeEvent: ', popStateEvent);
      // console.log('**flagged for animation stop');
      // console.log('detected user scrolling.  stopping scroll animation');  //works!
      // console.log('this.detectBackwardForward: ', this.detectBackwardForward);
      // console.log('scrolling...');
      // console.log('detected back/forward button pressed.  Cancelling animation.');
      // console.log('Proceeding with animation.');
            // var windowscrolltop = $(window).scrollTop();
      // console.log('windowScrolltop: ', windowscrolltop);



    // this.route.url.first().subscribe((url) => {
    //   console.log('url', url);
    // })
    // //children, url, fragment, queryparams, queryParamMap, root, data, component, firstChild


    // list - http://localhost:4200/products
    // * sku is null, 
    // edit-allfields - http://localhost:4200/admin/products/edit/1010
    
    // detail - http://localhost:4200/products/chocolatechip/1010
    
    // edit-card - http://localhost:4200/products/edit/card/1010
    
    // edit-detail - http://localhost:4200/products/edit/detail/1010


    //Psuedo-code logic to determine ProductsUrlType
          //url[0] == 'products' or 'admin'
      // let page = url[0].path;  //products or admin  //no!  'admin' route is not handled by products.component.  as defined in App.module, it will use admin.component.

      //if products
      // sku == 'null', show products list
      // sku != null, show detail
      
      //if admin
      //url[2] == 'card' or 'detail' or 'edit'
      //'edit, show edit-allfields
      //'card', show edit-card
      //'detail', show edit-detail

      
    
      // console.log('url[0]', url[0].path);
      // console.log('url[2]', url[2].path);
      // console.log('category', this.category);
      // console.log('sku', this.sku);

    // this.route.params.first().subscribe((params: Params) => {
    //   console.log('params:', params);
    // this.category = params["category"];
    // this.sku = params["sku"];
    // // if(this.sku){
    // //   this.urlType = ProductsUrlType.Edit;
    // // } else if (this.category == 'products'){
    // //   this.urlType = ProductsUrlType.List;
    // // } else if (this.category == 'customers'){
    // //   this.urlType = ProductsUrlType.Detail;
    // // } else if (this.category == null){
    // //   this.urlType = ProductsUrlType.Dashboard;
    // // }
    //   this.category_formatted = this.getCategoryFormatted(this.category);
    // });

  // console.log('productscomponent received products')
      // console.log('productResponse', productResponse);


  //moved to flatmap
  // //monitor the products for updates, if so then update the local list with a copy
  //   //  which will feed into the child components.
  //   this.productService.product$
  //   .takeUntil(this.ngUnsubscribe)
  //   .subscribe(products => {
    

  //   });


  // **this.products will be input to product-list, which can edit product.active.
      //   So this.products MUST be a copy of productService.product$.value
      // let productsCopy = Product.fromJsonList(products);  No.  Use original products.  We only need productCopy for a single product at a time via product edit component.  Let the edit components product the product copy.
      

   // //FILTER
      // //guard against null products
      // if(!this.products) { return }
      

          //unsubsribe from all subscriptions to prevent memory leak
    // this.subscriptions.unsubscribe();

      // //this works
      // //*note: setTimeout must be an arrowfunction to preserve 'this' context
      // setTimeout(() => {
      //   this.products = activeProducts;
      //   // this.products = ['goodbye', 'see ya'];
      //   console.log('this.products', this.products);  
      // }, 2000);
      // // this.products = ['hello'];




  //THIS WORKED, but probably not ideal to keep passing down a result object
  // *ideally you want each observable to emit a single value.
  //  "But I strongly suggest that you build your service-methods in a way that they return one single data-emission per method-call (unless the data is emitted over time and may not exist at the time of the method-call)"
  //  https://stackoverflow.com/questions/41834232/how-can-i-switchmap-2-observable-function-in-synchronous-fashion-but-get-the-fir

    // //Load the products here.  Use cached if available.
    // // Flatmapped with observable for changes in productService.product$.
    // // *flatMap = sequential order of execution of async methods
    // // *NO - this isn't the case: "an interesting consequence is the the subscribe is only called after loadproducts is complete,
    // //  so local products is never null".
    // //  *What's happening is that the urlType is initially null, so 'not handled'.  Thus initially, no url will be handled.
    // //   The urlType is ONLY decyphered AFTER loadAllProducts concludes due to the 'flatmap' sequential order.
    // //   Thus, products will exist at the time that urlType is assigned.
    
    // //1 - load products once
    // //2 - then evaluate the url on each change
    // //3 - merge the results each time with one/first observation of params.
    // //4 - merge the results with an Observable of each new 'products' received.  In case a product was edited causing productService.product$ to refresh
    // this.productService.loadAllProducts(true).first()
    // .flatMap( () => {
    //   // console.log('loaded products');  //called once due to first() on loadAllProducts
    //   return this.route.url;  //stream of url observations
    // })
    // .mergeMap(
    //   (url:UrlSegment[]) => {
    //     // console.log('new url.  combine with params at this url.');
    //     return this.route.params.first().map((params:Params) => { return {url:url, params:params} });
    //   }
    // )
    // .mergeMap( (result:{url:UrlSegment[], params:Params}) => {
    //   // console.log('new url/params combo.  combine with observable of products stream.', result);
    //   return this.productService.product$.map((products:Product[]) => { return {url:result.url, params:result.params, products:products} })
    // })
    // .mergeMap( (result:{url:UrlSegment[], params:Params, products:Product[]}) => {
    //   return this.authService.user$.map((user:User) => {
    //     return {url:result.url, params:result.params, products:result.products, user:user}
    //   });
    // })
    // .takeUntil(this.ngUnsubscribe)
    // .subscribe( (result:{url:UrlSegment[], params:Params, products:Product[], user:User}) => { 
    //   // console.log('subscribe');
    //   // console.log('params change', result.params);
    //   // console.log('merged with products received updated products: ', result.products);
    //   //use url / params to set local variables
    //   let url = result.url;
    //   let params = result.params;
    //   this.category = params["category"];
    //   this.sku = params["sku"];
    //   this.urlType = this.getProductsUrlType(url, this.sku);
    //   this.category_formatted = this.getCategoryFormatted(this.category);
    //   //assign the product, or null if no sku
    //   this.product = this.productService.getProductBySku(this.sku);
    //   //assign the user (can be null)
    //   this.user = result.user;
    //   // console.log('user', this.user);


    //   //filter products
    //   let filteredProducts = this.productService.getProductsByCategory(this.category); 
    //   // console.log('filtered products', filteredProducts);
    //   let activeProducts = Product.filterActiveProducts(filteredProducts);
    //   // console.log('activeProducts', activeProducts);
    //   this.products = activeProducts;      
      
    // });



  //TESTING ANGULAR TUPLES


//   simulateHttp(val: any, delay:number) {
//     return Observable.of(val).delay(delay);
// }

    // const course$ = this.simulateHttp({id:1, description: 'Angular For Beginners'}, 1000);
    
    // const httpResult$ = course$.switchMap(
    //     courses => this.simulateHttp([], 2000),
    //     (courses, lessons, outerIndex, innerIndex) => [courses, lessons] 
    // );
    
    // httpResult$.subscribe(
    //     console.log,
    //     console.error,
    //     () => console.log('completed httpResult$')
    // );



  //OBSOLETE.  Moved this to products.service

  // getProductForSku(sku:string){
  //   //if url is for a single product, grab the product
  //   let product:Product;
  //   if(sku){
  //     let filteredProduct = this.productService.getProductBySku(this.sku);
  //     product = filteredProduct;  //the actual product, not a copy
  //   } else{
  //     product = null;
  //   }
  //   return product;
  // }



// WEBPACK FOOTER //
// ./src/app/components/products/products.component.ts